import { nonEmptyArray } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';
import { flow } from 'fp-ts/lib/function';

export const selectHasLoadableViews: (s: GraphState) => boolean = flow(
  prop('loadViewDialog', 'views'),
  nonEmptyArray.isNonEmpty,
);
